import { IAuthByPinRequestOptions, IAuthByProviderRequestOptions, IAuthRequestOptions } from "../../Interfaces/AuthRequest";
import { IStringDict } from "../Values/types";

export const oauthLogInRoute = "/Auth/Authorize";
export const oauthLogin2FARoute = "/Auth/Authorize/2fa";
export const oauthLogInWithAccountLinkRoute = "/Auth/Authorize/completeAccountLink";
export const oauthLogInByPinRoute = "/Auth/Authorize/pin";
export const oauthLogInByProviderRoute = "/Auth/Authorize/provider";
export const oauthLogInErrorRoute = "/Auth/AuthorizeError";

export const authErrorRoute = "/AuthError";
export const loginRoute = "/login";

export interface IAuthStore {
  user: ISessionToken;
  isAuthorized: boolean;
  isUserTwoFactorAuthenticated: boolean;
  isTwoFactorAuthenticationRequired: boolean;
  isTwoFactorAuthenticationEnabledForUser: boolean;
  backUrl: string;
  userLocation: string;
  afterAuthRedirectUrl: string;
  redirectAfterLogin: string;
  personId: string;


  isAdmin: boolean;

  getUserDetails: () => void;
  getToken: () => Promise<string>;
  signIn: (login: string, password: string, locationId: string, tenant?: string, returnUrl?: string) => Promise<ISignInResult>;
  signInByPin: (pin: string, locationId: string, tenant?: string) => Promise<boolean>;
  signInWith2FA: (otp: string, tenant?: string) => Promise<ISignInResult>;

  signInViaExternalProvider: (
    oAuthProviderId: string,
    locationId: string,
    ssoPostBack: string,
    ssoPostBackMode: string,
    ssoPostBackHash: string,
    associatedPersonId?: string,
    tenant?: string,
    afterAuthRedirectUrl?: string
    ) => Promise<void>;

  signInViaOAuth2: (options: IAuthRequestOptions, queryParams: string, shouldLinkAccounts?: boolean) => void;
  signInViaOAuth2ByPin: (options: IAuthByPinRequestOptions, queryParams: string) => void;
  signInViaOAuth2ByProvider: (queryParams: string, options: IAuthByProviderRequestOptions) => void;

  getPin: () => Promise<string>;
  regeneratePin: () => Promise<string>;

  logOut: () => Promise<SignOut>;
  checkAuth: (tenant?: string) => Promise<boolean>;
  changeProfilePassword: (password: string) => Promise<IStringDict>;
  setBackUrl: (url: string) => void;
  setAfterAuthRedirectUrl: (url: string) => void;
  getPersonInitials: (name: string) => string;

  get2FASetup: () => Promise<SetupCode2FA>;
  enable2FA: (otpCode: string) => Promise<boolean>;
  disable2FA: (otpCode: string) => Promise<boolean>;
  disablePerson2FA: (id: string) => Promise<boolean>;

  Is2FASetupRequired: () => Promise<boolean>;
}

export class SignOut {
  message: string = "";
}

export class PinSignIn {
  location: string = "00000000-0000-0000-0000-000000000000";
  pin: string = "";
}

export class ChangePassword {
  password: string = "";
  id: string = "00000000-0000-0000-0000-000000000000";
}

export class SignIn {
  name: string = "";
  password: string = "";
  location: string = "";
  returnUrl: string = null;
}
export class TwoFactorAuthRequest {
    otpCode: string = "";
    returnUrl: string = null;
}
export class ProviderSignIn {
    oAuthProviderId: string = "";
    locationId: string = "";
    ssoPostBack: string = "";
    ssoPostBackMode: string = "";
    ssoPostBackHash: string = "";
    associatedPersonId: string = "";
}

export interface ISessionToken {
  person: ISessionTokenPerson;
  location: ISessionTokenLocation;
  position: SessionTokenPosition;
  session: string;
  expireTime: string;
  token: string;
  roles: string[];
  isTwoFactorAuthenticationRequired: boolean;
}

export interface ISignInResult {
    isTwoFactorAuthenticationRequired: boolean;
    isTwoFactorAuthenticationEnabledForUser: boolean;
    isUserTwoFactorAuthenticated: boolean;
    isAuthenticated: boolean;
    redirectAfterLogin?: string;
    personId: string;
}

export interface ISessionTokenPerson {
  fullName: string;
  email: string;
  organisation: string;
  apiKey: string;
  applicationUsedVersions: string[];
  name: string;
  id: string;
  profileImageUrl: string;
  twoFactorAuthenticationEnabled?: boolean;
}

export interface ISessionTokenLocation {
  type: number[];
  licencePlate: string;
  imoNumber: string;
  mmsiNumber: string;
  globalId: string;
  name: string;
  id: string;
  routeId: string;
  metaData: IStringDict;
  primary: boolean;
  timeZone: string;
}

export interface SessionTokenPosition {
  name: string;
  id: string;
}

export interface SetupCode2FA {
  setupUrl: string;
  setupCode: string;
}

